import isNil from 'lodash-es/isNil';
import React, { useEffect, useRef, useState } from 'react';
import { SelectChip } from '../chip';
import { TimeOption } from './TimePickerOptions';
import {
  time_chip_group_css,
  time_chip_label_css,
  time_chip_scroll_css,
  time_chip_scroll_fade_css,
  time_chip_scroll_fade_left_css,
  time_chip_scroll_wrapper_css,
} from './styles';

export interface TimeChipRowProps {
  unit: string;
  options: TimeOption[];
  selectedValue?: number;
  disabled?: boolean;
  onChange: (value: number) => void;
}

export const TimeChipRow = ({ unit, options, selectedValue, disabled, onChange }: TimeChipRowProps) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const selectedRef = useRef<HTMLButtonElement>(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(true);

  const updateFades = () => {
    const container = scrollRef.current;
    if (!container) {
      return;
    }
    setAtStart(container.scrollLeft <= 0);
    setAtEnd(Math.ceil(container.scrollLeft + container.clientWidth) >= container.scrollWidth);
  };

  // 선택 칩을 중앙으로 스크롤한다. 좌/우 끝이면 브라우저가 scrollLeft를 clamp해 경계에 머문다.
  useEffect(() => {
    const container = scrollRef.current;
    const node = selectedRef.current;
    if (isNil(selectedValue) || !container || !node) {
      return;
    }
    const containerRect = container.getBoundingClientRect();
    const nodeRect = node.getBoundingClientRect();
    const delta = nodeRect.left - containerRect.left - (containerRect.width - nodeRect.width) / 2;
    container.scrollTo({ left: container.scrollLeft + delta, behavior: 'smooth' });
  }, [selectedValue]);

  useEffect(updateFades, [options]);

  return (
    <div css={time_chip_group_css}>
      <span css={time_chip_label_css}>{unit}</span>
      <div css={time_chip_scroll_wrapper_css}>
        <div css={time_chip_scroll_css} ref={scrollRef} onScroll={updateFades}>
          {options.map((option) => (
            <SelectChip
              key={option.value}
              ref={selectedValue === option.value ? selectedRef : undefined}
              variant='filled'
              size='medium'
              label={`${option.label}${unit}`}
              selected={selectedValue === option.value}
              disabled={disabled || option.disabled}
              onClick={() => onChange(option.value)}
            />
          ))}
        </div>
        {!atStart && <div css={time_chip_scroll_fade_left_css} aria-hidden='true' />}
        {!atEnd && <div css={time_chip_scroll_fade_css} aria-hidden='true' />}
      </div>
    </div>
  );
};
